/* eslint-disable quotes */
"use strict";
const angular = require("angular");
var columns = [];
var colHeaders = [];
var updateDataObject = {};
var handsonData = [];
var regionalCodes = [];

var disabledHtmlRenderer = function (
  instance,
  td,
  row,
  col,
  prop,
  value,
  cellProperties
) {
  // be sure you only allow certain HTML tags to avoid XSS threats
  // (you should also remove unwanted HTML attributes)
  td.innerHTML = value;
  // td.style.fontWeight = 'bold';
  td.style.color = "black";
  td.style.border = "solid black 1px;";
  td.style.background = "#f1f1f1";
};

/*@ngInject*/
export function landuseService(lookup) {
  // Get regional zoning codes
  regionalCodes = lookup.getRegionalCodes();

  // Get and set table columns
  this.getColumns = function () {
    return columns;
  };

  this.setColumns = function (type) {
    console.log(type);
    // General Plan
    if (type === "gp") {
      //General Plan Codes
      columns = [
        {
          data: "gp_recid",
          editor: false,
        },
        {
          data: "gp_jurisdiction",
          editor: false,
        },
        {
          data: "gp_code",
          type: "text",
        },
        {
          data: "gp_description",
          type: "text",
        },
        {
          data: "gp_regional_description",
          editor: "chosen",
          type: "autocomplete",
          chosenOptions: {
            data: [
              {
                id: "Agriculture",
                label: "Agriculture",
              },
              {
                id: "Single Family Residential",
                label: "Single Family Residential",
              },
              {
                id: "Multi-Family Residential",
                label: "Multi-Family Residential",
              },
              {
                id: "Mixed Use Residential",
                label: "Mixed Use Residential",
              },
              {
                id: "Mixed Use Commercial",
                label: "Mixed Use Commercial",
              },
              {
                id: "Commercial",
                label: "Commercial",
              },
              {
                id: "Industrial",
                label: "Industrial",
              },
              {
                id: "Transportation",
                label: "Transportation",
              },
              {
                id: "Parks and Open Space",
                label: "Parks and Open Space",
              },
              {
                id: "Public and Institutional",
                label: "Public and Institutional",
              },
              {
                id: "Conservation and Ecology Areas",
                label: "Conservation and Ecology Areas",
              },
              {
                id: "Specific or Special Plan Areas",
                label: "Specific or Special Plan Areas",
              },
              {
                id: "Unclassified",
                label: "Unclassified",
              },
            ],
          },
        },
        {
          data: "gp_max_height",
          type: "text",
        },
        {
          data: "gp_units_per_lot",
          type: "text",
        },
        {
          data: "gp_min_dua",
          type: "text",
        },
        {
          data: "gp_max_dua",
          type: "text",
        },
        {
          data: "gp_max_far",
          type: "text",
        },
        {
          data: "gp_effective_date",
          type: "date",
          dateFormat: "MM/DD/YYYY",
          correctFormat: true,
        },
        {
          data: "gp_code_basis_url",
          type: "text",
        },
        {
          data: "gp_map_color",
          type: "text",
        },
        {
          data: "editor_id",
          type: "text",
          editor: false,
        },
        {
          data: "last_edited",
          type: "text",
          editor: false,
        },
        {
          data: "merge_code", //22
          type: "autocomplete",
          source: [
            "",
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
          ],
          strict: true,
        },
      ];
    } else if (type === "zn") {
      //Zoning Codes
      columns = [
        {
          data: "zn_recid", //0
          editor: false,
        },
        {
          data: "zn_jurisdiction", //1
          editor: false,
        },
        {
          data: "zn_code", //2
          type: "text",
        },
        {
          data: "zn_description", //3
          type: "text",
        },
        {
          data: "zn_regional_description", //4
          editor: "chosen",
          type: "autocomplete",
          chosenOptions: {
            data: [
              {
                id: "Agriculture",
                label: "Agriculture",
              },
              {
                id: "Single Family Residential",
                label: "Single Family Residential",
              },
              {
                id: "Multi-Family Residential",
                label: "Multi-Family Residential",
              },
              {
                id: "Mixed Use Residential",
                label: "Mixed Use Residential",
              },
              {
                id: "Mixed Use Commercial",
                label: "Mixed Use Commercial",
              },
              {
                id: "Commercial",
                label: "Commercial",
              },
              {
                id: "Industrial",
                label: "Industrial",
              },
              {
                id: "Transportation",
                label: "Transportation",
              },
              {
                id: "Parks and Open Space",
                label: "Parks and Open Space",
              },
              {
                id: "Public and Institutional",
                label: "Public and Institutional",
              },
              {
                id: "Conservation and Ecology Areas",
                label: "Conservation and Ecology Areas",
              },
              {
                id: "Specific or Special Plan Areas",
                label: "Specific or Special Plan Areas",
              },
              {
                id: "Unclassified",
                label: "Unclassified",
              },
            ],
          },
        },
        {
          data: "allows_residential", //5
          type: "dropdown",
          source: ["Yes", "No", "Unknown/No Data"],
        },
        {
          data: "zn_min_height", //6
          type: "text",
        },
        {
          data: "zn_max_height", //7
          type: "text",
        },
        {
          data: "zn_min_far", //8
          type: "text",
        },
        {
          data: "zn_max_far", //9
          type: "text",
        },
        {
          data: "zn_min_lot_sqft", //10
          type: "text",
        },
        {
          data: "zn_lot_coverage_pct", //11
          type: "text",
        },
        {
          data: "zn_min_dua", //12
          type: "text",
        },
        {
          data: "zn_max_dua", //13
          type: "text",
        },
        {
          data: "zn_units_per_lot", //14
          type: "text",
        },
        {
          data: "zn_side_setback_ft", //15
          type: "numeric",
        },
        {
          data: "zn_front_setback_ft", //16
          type: "numeric",
        },
        {
          data: "zn_rear_setback_ft", //17
          type: "numeric",
        },
        {
          data: "zn_code_basis_url", //18
          type: "text",
        },
        {
          data: "zn_effective_date", //19
          type: "date",
          dateFormat: "MM/DD/YYYY",
          correctFormat: true,
        },
        {
          data: "zn_map_color", //20
          type: "text",
        },
        {
          data: "editor_id", //21
          type: "text",
          editor: false,
        },
        {
          data: "last_edited", //22
          type: "text",
          editor: false,
        },
        {
          data: "merge_code", //22
          type: "autocomplete",
          source: [
            "",
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
          ],
          strict: true,
        },
      ];
    } else if (type === "report") {
      console.log("its a report");

      columns = [
        {
          data: "parcel_id",
          editor: false,
          readOnly: true,
        },
        {
          data: "jurisdiction",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "address",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "zip_code",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "apn",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "consolidated_sites",
          type: "autocomplete",
          source: [
            "",
            "A",
            "B",
            "C",
            "D",
            "E",
            "F",
            "G",
            "H",
            "I",
            "J",
            "K",
            "L",
            "M",
            "N",
            "O",
            "P",
            "Q",
            "R",
            "S",
            "T",
            "U",
            "V",
            "W",
            "X",
            "Y",
            "Z",
          ],
          strict: true,
        },
        {
          data: "gp_code",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "zn_code",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "zn_min_dua",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "zn_max_dua",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "acres",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "is_vacant",
          type: "autocomplete",
          source: ["YES", "NO"],
          strict: true,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "res_units",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "in_urban_area",
          type: "dropdown",
          source: ["YES", "NO"],
          strict: true,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "publicly_owned",
          type: "autocomplete",
          source: [
            "NO - Privately-Owned",
            "YES - City-Owned",
            "YES - County-Owned",
            "YES - Special District-Owned",
            "YES - State-Owned",
            "YES - Federally-Owned",
          ],
          strict: true,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "used_in_previous_rhna",
          type: "autocomplete",
          source: [
            "Used in Prior Housing Element - Vacant",
            "Used in Two Consecutive Housing Elements - Non-Vacant",
            "Not Used in Prior Housing Element",
          ],
          strict: true,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "resource_lvl",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "site_status",
          type: "autocomplete",
          source: ["", "Available", "Pending Project"],
          strict: true,
        },
        {
          data: "lwr_inc_cap",
          type: "numeric",
        },
        {
          data: "mod_inc_cap",
          type: "numeric",
        },
        {
          data: "abvmod_inc_cap",
          type: "numeric",
        },
        {
          data: "total_capacity",
          type: "numeric",
        },
        {
          data: "ceqa_elig",
          type: "autocomplete",
          source: [
            "",
            "NO - Not Eligible",
            "YES - Infill Cat.Ex. (CEQA Guidelines 15332)",
            "YES - Infill Housing Exemption (Public Resources Code (PRC) 21159.24)",
            "YES - Infill Housing in Unincorporated Areas (PRC) 21159.25",
            "YES - Transit Priority Area Covered by a Specific Plan (PRC) 21155.4",
            "YES - Planning Document Consistency (PRC) 21083.3",
            "YES - Other",
          ],
          strict: true,
        },
        {
          data: "max_capacity",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "hess_category",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "action_hab_haz_desc",
          type: "text",
          width: 250,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "action_pub_desc",
          type: "text",
          width: 250,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "action_vac_nonres_desc",
          type: "text",
          width: 250,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "action_vac_res_low_desc",
          type: "text",
          width: 250,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "action_vac_res_mod_desc",
          type: "text",
          width: 250,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "action_nonvac_nonres_desc",
          type: "text",
          width: 250,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "action_nonvac_res_desc",
          type: "text",
          width: 250,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "action_slr_77_desc",
          type: "text",
          width: 250,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "action_floodplain_desc",
          type: "text",
          width: 250,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "action_liq_desc",
          type: "text",
          width: 250,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "action_lotsize_feas_desc",
          type: "text",
          width: 250,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "action_repeat_site_desc",
          type: "text",
          width: 250,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "fire_haz_class",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "in_slr77",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "in_slr36",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "in_liquefact",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "in_seismic",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "in_floodplain",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "in_landslide",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "in_riparian",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "in_habitat",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "in_cpad",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_zero_fifty_ami",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_fifty_eighty_ami",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_eighty_hundred_ami",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_hundred_ami",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_non_hispanic_black",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_non_hispanic_white",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_non_hispanic_api",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_non_hispanic_other",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_hispanic_latinx",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_disability_status",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_family_households",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_non_family_households",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_single_person_households",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_households_with_children",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_costburdened_housing",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_overcrowded_housing",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_substandard_housing",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_displacement_risk",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_racially_concentrated_pov_flg",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "affh_racially_concentrated_aff_flg",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
      ];
    } else if (type === "reportRC") {
      console.log("its an RC report");

      columns = [
        {
          data: "report_id",
          editor: false,
          readOnly: true,
        },
        {
          data: "parcel_id",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "jurisdiction",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "address",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "zn_code",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "zn_regional_description",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "zn_min_dua",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "zn_max_dua",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "gp_min_dua",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "gp_max_dua",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "juris_default_density",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "acres",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "existing_use_description",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "market_area",
          type: "text",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "in_urban_area",
          type: "dropdown",
          source: ["YES", "NO"],
          strict: true,
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "real_capacity_lower",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "real_capacity_moderate",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "real_capacity_above_mod",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "adjustment_1",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "notes_1",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "notes_hess_1",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "adjustment_2",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "notes_2",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "notes_hess_2",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "adjustment_3",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "notes_3",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "notes_hess_3",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "adjustment_4",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "notes_4",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "notes_hess_4",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "adjustment_5",
          type: "numeric",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "notes_5",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        },
        {
          data: "notes_hess_5",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
        }
      ];
    } else if (type === "feedback") {
      columns = [
        {
          data: "recid",
          editor: false,
          readOnly: true,
        },
        {
          data: "status",
          type: "dropdown",
          source: ["", "submitted", "in review", "reviewed", "github"],
          strict: true,
        },
        {
          data: "type",
          type: "dropdown",
          source: [
            "Application Bug",
            "Data Issue",
            "Enhancement Request",
            "General Feedback",
          ],
          strict: true,
        },
        {
          data: "comment",
          type: "text",
          width: 700,
        },
        {
          data: "name",
          type: "text",
        },
        {
          data: "email",
          type: "text",
        },
        {
          data: "date",
          type: "date",
          editor: false,
          readOnly: true,
          renderer: disabledHtmlRenderer,
          dateFormat: "MM/DD/YYYY",
          correctFormat: true,
        },
      ];
    }
  };

  //Get and set table columns headers
  this.getColHeaders = function () {
    return colHeaders;
  };

  this.setColHeaders = function (type) {
    if (type === "gp") {
      colHeaders = [
        "RecID",
        "Jurisdiction Name",
        "General Plan Code",
        "General Plan Description",
        "Generalized Planned Uses",
        "Maximum Height",
        "Units per Lot",
        "Minimum DUA",
        "Maximum DUA",
        "Maximum FAR",
        "Effective Date",
        "Source URL",
        "Map Color",
        "Last Edited By",
        "Last Edit Date",
        "Flag as Duplicate",
      ];
    } else if (type === "zn") {
      colHeaders = [
        "RecID",
        "Jurisdiction Name",
        "Zoning Code",
        "Zoning Description",
        "Generalized Zoning Description",
        "Allows Residential",
        "Min Building Height (ft)",
        "Max Building Height (ft)",
        "Minimum FAR",
        "Maximum FAR",
        "Minimum Lot Sqft",
        "Lot Coverage(%)",
        "Minimum DUA",
        "Maximum DUA",
        "Units per Lot",
        "Side Setback (ft)",
        "Front Setback (ft)",
        "Rear Setback (ft)",
        "Source URL",
        "Effective Date",
        "Map Color",
        "Last Edited By",
        "Last Edit Date",
        "Flag as Duplicate",
      ];
    } else if (type === "report") {
      colHeaders = [
        "RecID",
        "Jurisdiction Name",
        "Site Address/Intersection",
        "5 Digit ZIP Code",
        "Assessor Parcel Number",
        "Consolidated Sites",
        "General Plan Designation (Current)",
        "Zoning Designation (Current)",
        "Minimum Density Allowed (units/acre)",
        "Max Density Allowed (units/acre)",
        "Parcel Size (Gross Acres)",
        "Existing Use/Vacancy",
        "No. of Units",
        "Infrastructure",
        "Publicly-Owned",
        "Identified in Last/Last Two Planning Cycle(s)",
        "HCD Resource Level",
        "Site Status",
        "Lower Income Capacity",
        "Moderate Income Capacity",
        "Above Moderate Income Capacity",
        "Total Capacity",
        "Eligible for CEQA Exemption and/or Streamlining",
        "Maximum Capacity",
        "Hess Category",
        "Proposed Action 1",
        "Proposed Action 2",
        "Proposed Action 3",
        "Proposed Action 4",
        "Proposed Action 5",
        "Proposed Action 6",
        "Proposed Action 7",
        "Proposed Action 8",
        "Proposed Action 9",
        "Proposed Action 10",
        "Proposed Action 11",
        "Proposed Action 12",
        "Wildfire Risk",
        "Sea Level Rise (77inch)",
        "Sea Level Rise (36inch)",
        "Liquefaction",
        "Earthquake/Seismic",
        "Floodplains",
        "Landslide Risk",
        "Riparian Area",
        "Critical Habitat",
        "Ca. Protected Area",
        "Tract: 0-50% AMI (%)",
        "Tract: 50%-80% AMI (%)",
        "Tract: 80%-100% AMI (%)",
        "Tract: > 100% AMI (%)",
        "Tract: Non-Hispanic Black (%)",
        "Tract: Non-Hispanic White (%)",
        "Tract: Non-Hispanic API (%)",
        "Tract: Non-Hispanic Other (%)",
        "Tract: Hispanic/Latinx (%)",
        "Tract: Disablity Status (%)",
        "Tract: Family Households (%)",
        "Tract: Non-Family Households (%)",
        "Tract: Single-person Households (%)",
        "Tract: Households with Children (%)",
        "Tract: Cost-burdened Households (%)",
        "Tract: Over-crowded Households (%)",
        "Tract: Substandard Housing (%)",
        "Tract: Displacement Risk",
        "Tract: Racially/Ethnically Concentrated Area of Poverty",
        "Tract: Racially Concentrated Area of Affluence"
      ];
    } else if (type === "reportRC") {
      colHeaders = [
        "ReportID",
        "ParcelId",
        "Jurisdiction Name",
        "Site Address/Intersection",
        "Zoning Designation (Current)",
        "Zoning Regional Designation (Current)",
        "Zoning Min Density Allowed (units/acre)",
        "Zoning Max Density Allowed (units/acre)",
        "General Plan Min Density Allowed (units/acre)",
        "General Plan Max Density Allowed (units/acre)",
        "HCD Default Density (units/acre)",
        "Parcel Size (Gross Acres)",
        "Existing Use/Vacancy",
        "Market Area",
        "Infrastructure",
        "Lower Income Capacity",
        "Moderate Income Capacity",
        "Above Moderate Income Capacity",
        "Zoning Adjustment",
        "Local Zoning Notes",
        "HESS Zoning Notes",
        "Affordability Adjustment",
        "Local Affordability Notes",
        "HESS Affordability Notes",
        "Infrastructure Adjustment",
        "Local Infrastructure Notes",
        "HESS Infrastructure Notes",
        "Environmental Adjustment",
        "Local Environmental Notes",
        "HESS Environmental Notes",
        "Nonresidential-Nonvacant Adjustment",
        "Nonresidential-Nonvacant Notes",
        "HESS Nonresidential-Nonvacant Notes"
      ];
    } else if (type === "feedback") {
      colHeaders = [
        "RecID",
        "Status",
        "Type",
        "Comment",
        "Name",
        "Email",
        "Date",
      ];
    }
  };

  /*
Get and set update data depending on which table is being edited
  */
  this.getHandsOnUpdate = function () {
    return updateDataObject;
  };

  this.setHandsOnUpdate = function (type, handsonUpdate) {
    updateDataObject = handsonUpdate;
  };

  // Get and Set Local Copy of Handsontable Data
  this.getHandsOnData = function () {
    return handsonData;
  };

  this.setHandsOnData = function (data) {
    handsonData = data;
  };
}

export default angular
  .module("hessApplicationApp.landuse", [])
  .service("landuse", landuseService).name;



// WEBPACK FOOTER //
// ./client/components/services/landuse/landuse.service.js